import React from "react";
import { brandConfig, getCopyrightText } from "../config/brand.config";

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <hr />
      <div className="footer-content">
        <p
          className="company-name"
          style={{ fontSize: ".75rem", marginTop: "5px" }}
        >
          <a
            style={{
              textDecoration: "none",
            }}
            href="/tnc"
          >
            Terms & Condition & Refund
          </a>{" "}
          |{" "}
          <a
            style={{
              textDecoration: "none",
            }}
            href="/privacy"
          >
            Privacy Policy
          </a>
        </p>
        <p className="company-name">Powered by {brandConfig.appName}</p>
        <p className="rights">{getCopyrightText()}</p>
        <a href={`mailto:${brandConfig.companyEmail}`}>{brandConfig.companyEmail}</a>
      </div>
    </footer>
  );
};

export default Footer;
